import React from 'react';
import { Container, Row, Col, Card, Table } from 'react-bootstrap';

const ProductwiseBi = () => {
  // Sample product-wise data
  const productData = [
    {
      product: 'Mobile Recharge',
      transactions: 15890,
      revenue: '₹52,67,890',
      commission: '₹2,63,395',
      growth: '+18.5%',
      growthType: 'positive',
      icon: 'bi bi-phone',
      color: 'primary'
    },
    {
      product: 'Bill Payment',
      transactions: 12340,
      revenue: '₹89,45,670',
      commission: '₹4,47,284',
      growth: '+15.2%',
      growthType: 'positive',
      icon: 'bi bi-receipt',
      color: 'success'
    },
    {
      product: 'Money Transfer',
      transactions: 8970,
      revenue: '₹1,25,56,780',
      commission: '₹6,27,839',
      growth: '+22.3%',
      growthType: 'positive',
      icon: 'bi bi-arrow-left-right',
      color: 'info'
    },
    {
      product: 'AEPS',
      transactions: 6780,
      revenue: '₹45,90,450',
      commission: '₹2,29,523',
      growth: '+12.8%',
      growthType: 'positive',
      icon: 'bi bi-credit-card',
      color: 'warning'
    },
    {
      product: 'DTH Recharge',
      transactions: 5640,
      revenue: '₹18,78,900',
      commission: '₹93,945',
      growth: '-3.5%',
      growthType: 'negative',
      icon: 'bi bi-broadcast',
      color: 'danger'
    }
  ];

  const topOperators = [
    { name: 'Airtel', transactions: 4500, share: '28%' },
    { name: 'Jio', transactions: 3800, share: '24%' },
    { name: 'VI', transactions: 3200, share: '20%' },
    { name: 'BSNL', transactions: 2100, share: '13%' },
    { name: 'Others', transactions: 2400, share: '15%' }
  ];

  return (
    <Container fluid className="">
      {/* Page Header */}
      <div className="mb-4">
        <h4 className="mb-1" style={{ color: '#1e293b', fontWeight: '700', fontSize: '1.5rem' }}>
          Productwise Business Intelligence
        </h4>
        <p className="text-muted mb-0" style={{ fontSize: '0.9rem' }}>
          Product performance analytics and revenue insights
        </p>
      </div>

      {/* Product Performance Cards */}
      <Row className="mb-4">
        {productData.map((product, index) => (
          <Col key={index} xs={12} sm={6} lg={4} xl className="mb-3">
            <Card className="border-0 shadow-sm h-100">
              <Card.Body>
                <div className="d-flex justify-content-between align-items-start mb-3">
                  <div className={`text-${product.color}`}>
                    <i className={`${product.icon} fs-3`}></i>
                  </div>
                  <span className={`badge bg-${product.growthType === 'positive' ? 'success' : 'danger'}`}>
                    {product.growth}
                  </span>
                </div>
                <h6 className="mb-3" style={{ fontSize: '0.875rem', fontWeight: '600', color: '#64748b' }}>
                  {product.product}
                </h6>
                <div className="mb-2">
                  <small className="text-muted d-block">Transactions</small>
                  <strong style={{ fontSize: '1.1rem' }}>{product.transactions.toLocaleString()}</strong>
                </div>
                <div className="mb-2">
                  <small className="text-muted d-block">Revenue</small>
                  <strong style={{ fontSize: '1rem', color: '#10b981' }}>{product.revenue}</strong>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Detailed Analytics */}
      <Row>
        <Col lg={8} className="mb-4">
          <Card className="border-0 shadow-sm h-100">
            <Card.Body>
              <h5 className="mb-4" style={{ fontWeight: '700', color: '#1e293b' }}>
                Product-wise Performance Details
              </h5>
              <div className="table-responsive">
                <Table hover className="mb-0">
                  <thead style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white' }}>
                    <tr>
                      <th>Product</th>
                      <th>Transactions</th>
                      <th>Revenue</th>
                      <th>Commission</th>
                      <th>Growth</th>
                    </tr>
                  </thead>
                  <tbody>
                    {productData.map((product, index) => (
                      <tr key={index}>
                        <td>
                          <i className={`${product.icon} me-2 text-${product.color}`}></i>
                          <strong>{product.product}</strong>
                        </td>
                        <td>{product.transactions.toLocaleString()}</td>
                        <td style={{ fontWeight: '600', color: '#10b981' }}>{product.revenue}</td>
                        <td style={{ fontWeight: '600' }}>{product.commission}</td>
                        <td>
                          <span className={`text-${product.growthType === 'positive' ? 'success' : 'danger'}`}>
                            {product.growth}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={4} className="mb-4">
          <Card className="border-0 shadow-sm h-100">
            <Card.Body>
              <h5 className="mb-4" style={{ fontWeight: '700', color: '#1e293b' }}>
                Top Operators
              </h5>
              {topOperators.map((operator, index) => (
                <div key={index} className="mb-4">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div>
                      <span style={{ fontSize: '0.875rem', fontWeight: '600' }}>
                        {operator.name}
                      </span>
                      <small className="text-muted d-block">{operator.transactions} txns</small>
                    </div>
                    <span className="badge bg-primary">
                      {operator.share}
                    </span>
                  </div>
                  <div className="progress" style={{ height: '8px' }}>
                    <div 
                      className="progress-bar bg-primary"
                      style={{ width: operator.share }}
                    ></div>
                  </div>
                </div>
              ))}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ProductwiseBi;

